import { Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Grid, _ } from "gridjs-react";
import { useEffect, useState } from "react";
import Rest from "./../../libraries/Rest";
import LocalStorage from "./../../libraries/LocalStorage";
import Alert from "./../../libraries/Alert";

import * as Components from "./../../components/Components";

function PayrollList() {
    const rest = new Rest();
    const localStorage = new LocalStorage();
    const roleName = localStorage.getItem('role_name');
    const allowedRole = 'super_admin'; // static role validation (code: VL01)

    const navigate = useNavigate();
    const [companies, setCompanies] = useState([]);
    const [companyId, setCompanyId] = useState();

    const endpoint = `/payrolls`;
    const rootPath = `/payrolls`;

    const getCompanies = async () => {
        let res = await rest.get(`/companies?page=1&limit=100`);
        if (res?.data?.data?.data !== undefined) {
            res = res.data.data.data;

            let options = [];
            for (let i = 0; i < res.length; i++) {
                options.push({
                    value: res[i]['id'] !== undefined ? res[i]['id'] : null,
                    label: res[i]['name'] !== undefined ? res[i]['name'] : null,
                });
            }
            setCompanies(options);
        }
    }

    const updatePayload = async (_, value) => {
        setCompanyId(value);
    }

    useEffect(() => {
        if (roleName?.toLowerCase() === allowedRole) getCompanies(); // static role validation (code: VL01)
    }, []);

    const openPage = (id, type) => {
        if (type === 'detail') {
            navigate(`${rootPath}/detail/${id}`);
        } else {
            navigate(`${rootPath}/${id}`);
        }
    }

    const removeItem = async (id) => {
        Alert.showConfirm({
            url: `${endpoint}/${id}`,
            method: 'DELETE',
        }).then((result) => {
            if (result.isConfirmed) {
                if (result?.value?.success) {
                    Alert.showMessage('Success', 'success', result?.value?.data?.message);
                    navigate(`${rootPath}`)
                } else {
                    Alert.showMessage('Failure', 'error', result?.value?.message);
                }
            }
        });
    }

    return (
        <div>
            <Card className="bg-white">
                <Card.Header className="bg-primary">
                    <Card.Title as="label" className="fs-sm fw-medium mb-1 text-white">
                        List of Payrolls
                    </Card.Title>
                </Card.Header>
                <Card.Body className="bg-white">
                    {roleName?.toLowerCase() === allowedRole && <Row>
                        <Col sm="3">
                            <Components.Select
                                label="Company"
                                name="companyId"
                                defaultValue={companyId}
                                change={updatePayload}
                                options={companies}
                            />
                        </Col>
                    </Row>}
                    <Grid
                        className={{ table: 'table table-bordered mb-0' }}
                        resizable={true}
                        language={{
                            search: {
                                placeholder: 'Find something..'
                            }
                        }}
                        columns={[
                            'Company',
                            'Start Date',
                            'End Date',
                            'Remark',
                            'Status',
                            'Type',
                            'Actions',
                        ]}
                        server={{
                            url: `${rest.MAIN_HOST}${endpoint}${companyId !== '' && companyId !== null && companyId !== undefined ? '?companyId=' + companyId : ''}`,
                            headers: {
                                'authorization': `Bearer ${rest.ACCESS_TOKEN}`
                            },
                            then: data => data?.data?.data?.map(r => [
                                r?.companies?.name,
                                r.start_date,
                                r?.end_date,
                                r?.remark,
                                r?.status_text,
                                r?.type_text,
                                _(
                                    <div style={{ textAlign: 'center' }}>
                                        {r?.status?.toUpperCase() !== 'S1' && <button type="button" onClick={() => openPage(r.id, 'detail')} className="btn btn-info btn-sm text-white" title="Detail data"><i className="ri-eye-line"></i></button>}
                                        {r?.status?.toUpperCase() === 'S1' && <button type="button" onClick={() => openPage(r?.id, 'edit')} className="btn btn-sm btn-success text-white" style={{ marginLeft: 5, marginRight: 5 }}>
                                            <i className="ri-pencil-line"></i>
                                        </button>}
                                        {r?.status?.toUpperCase() === 'S1' && <button type="button" onClick={() => removeItem(r?.id)} className="btn btn-sm btn-danger text-white">
                                            <i className="ri-delete-bin-line"></i>
                                        </button>}
                                    </div>
                                )
                            ]),
                            total: data => data?.data?.total?.data,
                            handle: (res) => {
                                if (res.status === 401) return rest.interceptor();
                                return res.json();
                            }
                        }}
                        search={{
                            server: {
                                url: (prev, keyword) => `${prev}?keywords=${keyword}`
                            }
                        }}
                        pagination={{
                            limit: 10,
                            server: {
                                url: (prev, page, limit) => {
                                    const operator = prev.includes('?') ? '&' : '?';
                                    if (parseInt(page) <= 0) page = 1;
                                    return `${prev}${operator}limit=${limit}&page=${page}`
                                }
                            }
                        }}
                    />
                </Card.Body>
            </Card>
        </div>
    )

}

export default PayrollList;